import http from "../../http-common";
/* eslint-disable */
class ObatService {
  obatList(page, itemPerPage, keyword) {
    return http.get(
      "/obat/list?page=" +
        page +
        "&item_per_page=" +
        itemPerPage +
        "&keyword=" +
        keyword,
      {
        headers: {
          "Content-type": "application/json",
          Authorization:
            "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
        },
      },
    );
  }

  create(data) {
    var bodyFormData = new FormData();
    bodyFormData.append("nama", data.nama);
    bodyFormData.append("deskripsi", data.deskripsi);
    bodyFormData.append("harga", data.harga);
    bodyFormData.append("stok", data.stok);
    bodyFormData.append("kode", data.kode);

    if (data.selectedKategori && data.selectedKategori != undefined) {
      bodyFormData.append("category_id", data.selectedKategori.id);
    }

    if (data.selectedUnit && data.selectedUnit != undefined) {
      bodyFormData.append("unit_id", data.selectedUnit.id);
    }

    if (data.selectedSupplier && data.selectedSupplier != undefined) {
      bodyFormData.append("supplier_id", data.selectedSupplier.id);
    }

    return http.post("/obat", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }

  update(id, data) {
    var bodyFormData = new FormData();
    bodyFormData.append("id", id);
    bodyFormData.append("nama", data.nama);
    bodyFormData.append("deskripsi", data.deskripsi);
    bodyFormData.append("kode", data.kode);

    bodyFormData.append("harga", data.harga);
    bodyFormData.append("stok", data.stok);

    if (data.selectedKategori && data.selectedKategori != undefined) {
      bodyFormData.append("category_id", data.selectedKategori.id);
    }

    if (data.selectedUnit && data.selectedUnit != undefined) {
      bodyFormData.append("unit_id", data.selectedUnit.id);
    }

    if (data.selectedSupplier && data.selectedSupplier != undefined) {
      bodyFormData.append("supplier_id", data.selectedSupplier.id);
    }

    return http.put(`/obat/${id}`, bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }

  delete(id) {
    return http.delete(`/obat/${id}`, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }

  uploadObat(data) {
    var bodyFormData = new FormData();

    if (data) bodyFormData.append("file", data);

    return http.post("/obat/upload", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
      timeout: 1000000000,
    });
  }
}

export default new ObatService();
